import { SegmentData } from "../../types";
import { i18nLanguage } from "i18n";
import { DistanceUnit } from "shared/types";
import { formatDistance } from "shared/utils/formatDistance";
import { getLocalizedString } from "../../utils/getLocalizedString";

type TripperSegmentHeaderProps = {
  segment: SegmentData;
  language: i18nLanguage;
  isActive: boolean;
  distanceMeters?: number | null;
  isMultiDay?: boolean;
  dayNumber?: number;
  unit?: DistanceUnit;
};

export const TripperSegmentHeader = ({
  segment,
  language,
  isActive: _isActive,
  distanceMeters,
  isMultiDay = false,
  dayNumber = 1,
  unit = "metric",
}: TripperSegmentHeaderProps) => {
  const label = segment.label ? getLocalizedString(segment.label, language) : "";
  const normalizedLabel = label.trim().toLowerCase();
  const defaultDayLabel = `Day ${Math.max(1, dayNumber)}`;
  const isDefaultMultiDayLabel = isMultiDay
    && (normalizedLabel === "" || normalizedLabel === defaultDayLabel.toLowerCase());
  const showDayBadge = isMultiDay && !isDefaultMultiDayLabel;
  const displayTitle = isDefaultMultiDayLabel ? defaultDayLabel : label;
  const distance = (typeof distanceMeters === "number" && distanceMeters > 0)
    ? formatDistance(distanceMeters, unit)
    : null;

  return (
    <div className={`tripper-day-header${showDayBadge ? " tripper-day-header--multi-renamed" : ""}`}>
      {showDayBadge ? (
        <>
          <h2 className="tripper-day-header__title">{displayTitle}</h2>
          <div className="tripper-day-header__meta">
            {distance ? (
              <span className="tripper-day-header__distance">{distance}</span>
            ) : null}
            <span className="tripper-day-header__day-badge">{defaultDayLabel}</span>
          </div>
        </>
      ) : (
        <>
          <h2 className="tripper-day-header__title">{displayTitle}</h2>
          {distance ? (
            <span className="tripper-day-header__distance">{distance}</span>
          ) : null}
        </>
      )}
    </div>
  );
};
